import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../shared/models/api-response.model';
import { HttpCommonService } from '../../../shared/services/http-common-service';
import { NotificationCreateDto, NotificationListDto } from '../models/notification.models';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private baseUrl = `Notification`;

  constructor(private httpCommonService: HttpCommonService) { }

  getNotifications(pageNumber: number = 1, pageSize: number = 10): Observable<ApiResponse<NotificationListDto>> {
    return this.httpCommonService.get<ApiResponse<NotificationListDto>>({
      url: `${this.baseUrl}?pageNumber=${pageNumber}&pageSize=${pageSize}`
    });
  }

  getUnreadCount(): Observable<ApiResponse<number>> {
    return this.httpCommonService.get<ApiResponse<number>>({
      url: `${this.baseUrl}/UnreadCount`
    });
  }

  markAsRead(id: string): Observable<ApiResponse<boolean>> {
    return this.httpCommonService.put<ApiResponse<boolean>>({
      url: `${this.baseUrl}/${id}/MarkAsRead`
    });
  }

  markAllAsRead(): Observable<ApiResponse<boolean>> {
    return this.httpCommonService.put<ApiResponse<boolean>>({
      url: `${this.baseUrl}/MarkAllAsRead`
    });
  }

  create(model: NotificationCreateDto): Observable<ApiResponse<string>> {
    return this.httpCommonService.post<ApiResponse<string>>({
      url: `${this.baseUrl}/Create`,
      body: model
    });
  }

  createMultiple(notifications: NotificationCreateDto[]): Observable<ApiResponse<boolean>> {
    return this.httpCommonService.post<ApiResponse<boolean>>({
      url: `${this.baseUrl}/CreateMultiple`,
      body: notifications
    });
  }

  delete(id: string): Observable<ApiResponse<boolean>> {
    return this.httpCommonService.delete<ApiResponse<boolean>>({
      url: `${this.baseUrl}/${id}`
    });
  }

  deleteMultiple(ids: string[]): Observable<ApiResponse<boolean>> {
    return this.httpCommonService.post<ApiResponse<boolean>>({
      url: `${this.baseUrl}/DeleteMultiple`,
      body: ids
    });
  }
}
